<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'service.survey-service.question-final-decision-statuses.revised.title' | translate }}</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()" class="ml-auto">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="m-5">
  <app-single-question [question]="newQuestion" [clonable]="false" [editable]="true"
                       [isResponse]="false"></app-single-question>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mt-5 mb-2">
  <button mat-button (click)="close()">{{ 'generic.cancel' | translate }}</button>
  <button mat-raised-button (click)="cancelDecision()">{{ 'generic.cancel-decision' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()">{{ 'generic.buttons.save' | translate }}</button>
</mat-dialog-actions>
